import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.assign.js";
import UA from '../ua';
import Env from '../env';
import Platform from '../platform';
import Url from './url';
import KNB from '@dp/knb';
import Cookie from './cookie';
import ACTIVITY_TAG from '../config/activityTag';
import { TJBridge } from '../platform/tengjing';
import parseUrl from 'url-parse';
import KNBCore from '@mtfe/knb-core';
var KNBP = KNB.getPromiseInstance();
var urlPerfix = Platform.urlPerfix,
  _Platform$linkMap = Platform.linkMap,
  linkMap = _Platform$linkMap === void 0 ? {} : _Platform$linkMap;
var isProduct = Env.isProduct,
  isPpe = Env.isPpe,
  isLocal = Env.isLocal;
var showUrlRegx = /\/(myshow|movieshow|movieshowlist|movieshoworder|selfsale)\/?/;
var raletiveUrlCover = function raletiveUrlCover(url) {
  // 处理相对路径跳转问题
  var Href = location.href;
  var uri = Url.parse(Href).uri;
  if (/(^[?#&]|\/$)/.test(url)) url = uri + url;else {
    var str = uri.split('/').pop() + '/?$';
    url = uri.replace(new RegExp(str), url);
  }
  return url;
};
export var getUrl = function getUrl(url) {
  url = url.trim();

  // if (!/^\//.test(url)) url = raletiveUrlCover(url)

  var _Url$parse = Url.parse(url),
    uri = _Url$parse.uri,
    hash = _Url$parse.hash,
    query = _Url$parse.query;

  // 兼容运营位置以前运营用乱带fromTag的问题
  if (query) {
    var activityTag = query[ACTIVITY_TAG.STATS_TAG] || query[ACTIVITY_TAG.FROM_TAG];
    if (query[ACTIVITY_TAG.FROM_TAG]) delete query[ACTIVITY_TAG.FROM_TAG];
    if (activityTag) query[ACTIVITY_TAG.STATS_TAG] = activityTag;
  }
  /** 灰度测试专用 */
  var isGray = location.search.includes('isshowgray=true');
  if (isGray) query.isshowgray = true;
  /** 灰度测试专用 */

  // 演出相关路径 需要特殊处理， 以处理路径映射 及 fromTag 问题等
  if (showUrlRegx.test(uri)) {
    // 携带 fromTag
    var fromTag = Url.getQuery('fromTag') || Url.getQuery('utm_source') || Url.getHashQuery('utm_source');
    if (fromTag) query.fromTag = query.utm_source = fromTag;

    // cookie 中含有 ACTIVITY_TAG.STATS_TAG 需要带到下个链接
    var utmContent = '';
    var utmCookie = Cookie.get('_lx_utm');
    if (utmCookie) {
      var utm = Url.parseQuery(utmCookie);
      Object.keys(utm).forEach(function (key) {
        if (key === ACTIVITY_TAG.STATS_TAG) {
          utmContent = utm[key];
        }
      });
    }
    if (utmContent && !query[ACTIVITY_TAG.STATS_TAG]) query[ACTIVITY_TAG.STATS_TAG] = utmContent;

    // 清理前缀
    uri = uri.replace(/^(.*\.com\/app\/)/, '/');

    // 判断是否包含地址映射
    if (linkMap[uri]) uri = linkMap[uri];

    // 替换域名路径替换域名路径
    url = Url.stringify(urlPerfix.replace(/[?#/&]$/, '') + uri, query, hash);
    if (!/^https?/.test(url)) url = location.protocol + url;
  }
  return url;
};
var redirect = function redirect(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    jump: false,
    _blank: true
  };
  var jump = options.jump,
    _blank = options._blank,
    unFormate = options.unFormate;
  url = unFormate ? url : getUrl(url);

  /** 灰度测试专用 */
  var isGray = location.search.includes('isshowgray=true');
  if (isGray) {
    var _Url$parse2 = Url.parse(url),
      uri = _Url$parse2.uri,
      hash = _Url$parse2.hash,
      query = _Url$parse2.query;
    query.isshowgray = true;
    url = Url.stringify(uri, query, hash);
  }
  /** 灰度测试专用 */

  if (UA.IS_TENGJING) {
    // 腾竞 APP 页面跳转
    return TJBridge.openWebview({
      url: url,
      jump: jump
    });
  }

  // 美团小程序直接新开webview页面
  if (UA.IS_QQWALLET && window.Drip && window.Drip.constant.isFromMtwxapp && window.wx) {
    var webviewUrl = "/index/pages/h5/h5?weburl=" + encodeURIComponent(url);
    wx.miniProgram.navigateTo({
      url: webviewUrl
    });
    return;
  }

  // 抖音演出小程序
  if (UA.IS_DouyinShowMicroApp) {
    var result = url.match(/.*#\/detail\/(\d+).*/);
    var miniUrl = "/pages/show/webview/webview?url=" + encodeURIComponent(url);
    if (result && result[1]) {
      // 项目详情页面跳转, 旧的项目详情地址
      miniUrl = "/pages/show/detail/index?id=".concat(result[1]);
    }
    window.tt.miniProgram.navigateTo({
      url: miniUrl
    });
    return;
  }
  if (isLocal || !UA.isNative || /^(dianping|imeituan):\/\//.test(url)) {
    // 本地 或者 非Native环境 或者 带协议的链接 直接跳转
    location.href = url;
    return;
  }
  if (_blank === undefined) _blank = true;
  var qs = {
    noquery: 1
  };
  if (UA.isNative && _blank) {
    // native 环境默认使用 openwebview 方式
    if (UA.IS_MEITUAN) {
      // wkwebview 切换
      var needWkWebview;
      try {
        needWkWebview = KNB.Semver.gte(UA.appVersion, '9.10.6');
      } catch (e) {
        console.error(e);
      }
      if (jump) {
        return KNB.jumpWebview({
          url: url,
          qs: Object.assign({}, qs, {
            wkwebview: needWkWebview ? 1 : 0
          })
        });
      } else {
        // 美团跳转需要特殊处理， 兼容老版美团版本 knb 不支持情况
        url = "imeituan://www.meituan.com/web?noquery=1".concat(needWkWebview ? '&wkwebview=1' : '', "&url=") + encodeURIComponent(url);
        var a = document.createElement('a');
        a.href = url;
        a.click();
      }
      return;
    }
    if (!jump && UA.IS_MAOYAN && UA.osName === 'android') {
      // 猫眼 android 跳转需要特殊处理， 手机端需要唤起摄像头
      if (KNBCore.compareVersion(UA.appVersion, '9.20.0') >= 0) {
        // android 9.20.0 版本后要把concert_verify参数放在url里
        var urlObj = parseUrl(url, true);
        urlObj.set('query', Object.assign({}, urlObj.query, {
          concert_verify: 1
        }));
        url = urlObj.toString();
        url = "meituanmovie://www.meituan.com/web?url=".concat(encodeURIComponent(url));
      } else {
        url = "meituanmovie://www.meituan.com/web?url=".concat(encodeURIComponent(url), "#concert_verify");
      }
      var _a = document.createElement('a');
      _a.href = url;
      _a.click();
      return;
    }
    if (jump) return KNBP.jumpWebview({
      url: url
    });
    return KNBP.openWebview({
      url: url,
      qs: qs
    });
  }
  location.href = url;
};
redirect.getUrl = getUrl;
export default redirect;